import { useEffect, useState } from "react";
import api from "../../../../Component/axios";

export const useBultos = (id_tipo_caja) => {
  const [bultos, setBultos] = useState([]);

  useEffect(() => {
    const getButlos = async () => {
      const token = localStorage.getItem("@Token");
      try {
        const response = await api.get(`api/etiquetas/bultos_palet/`, {
          params: { id_tipo_caja },
          headers: {
            Authorization: "Token " + token,
          },
        });
        setBultos(response.data);
      } catch (error) {
        console.log(error);
      }
    };
    getButlos();
  }, [id_tipo_caja]);

  return { bultos };
};
